/**
 * 办办 OAuth2 跳转（对齐易直签）：办办内账号授权，站外扫码。
 */
export function isEmbeddedInIframe() {
    try {
        return window.self !== window.top;
    }
    catch {
        return true;
    }
}
export function buildBanbanOauthUrl(pageBase, clientId, redirectUri) {
    const base = (pageBase || '').trim();
    const sep = base.includes('?') ? '&' : '?';
    return `${base}${sep}client_id=${encodeURIComponent(clientId)}`
        + `&response_type=code`
        + `&redirect_uri=${encodeURIComponent(redirectUri)}`;
}
function pickParam(search, ...keys) {
    for (const key of keys) {
        const value = search.get(key);
        if (value) {
            return value;
        }
    }
    return '';
}
/**
 * 解析办办回跳参数（search 或 hash 上的 accessToken/code）。
 */
export function parseBanbanOauthCallback() {
    const search = new URLSearchParams(window.location.search);
    let accessToken = pickParam(search, 'accessToken', 'access_token');
    let code = pickParam(search, 'code');
    let error = pickParam(search, 'error', 'ssoError');
    const hash = window.location.hash || '';
    const hashQueryAt = hash.indexOf('?');
    if (hashQueryAt >= 0) {
        const hashParams = new URLSearchParams(hash.slice(hashQueryAt + 1));
        accessToken = accessToken || pickParam(hashParams, 'accessToken', 'access_token');
        code = code || pickParam(hashParams, 'code');
        error = error || pickParam(hashParams, 'error', 'ssoError');
    }
    if (accessToken.includes('#')) {
        accessToken = accessToken.split('#')[0];
    }
    return { accessToken, code, error };
}
export function stripBanbanOauthQuery() {
    const url = new URL(window.location.href);
    ['accessToken', 'access_token', 'code', 'error', 'ssoError', 'ssoTicket', 'isBanban', 'state']
        .forEach(key => url.searchParams.delete(key));
    const hash = url.hash || '';
    const q = hash.indexOf('?');
    if (q >= 0) {
        const path = hash.slice(0, q);
        const hp = new URLSearchParams(hash.slice(q + 1));
        ['accessToken', 'access_token', 'code', 'error', 'ssoError', 'ssoTicket', 'isBanban', 'state']
            .forEach(key => hp.delete(key));
        const rest = hp.toString();
        url.hash = rest ? `${path}?${rest}` : path;
    }
    window.history.replaceState({}, '', url.toString());
}
const SKIP_AUTO_KEY = 'jitsi.portal.ssoSkipAuto';
export function skipAutoSso() {
    try {
        return sessionStorage.getItem(SKIP_AUTO_KEY) === '1';
    }
    catch {
        return false;
    }
}
export function markSkipAutoSso() {
    try {
        sessionStorage.setItem(SKIP_AUTO_KEY, '1');
    }
    catch {
        // ignore
    }
}
export function clearSkipAutoSso() {
    try {
        sessionStorage.removeItem(SKIP_AUTO_KEY);
    }
    catch {
        // ignore
    }
}
